export function expandTextarea() {
  function autoExpand(event) {
    const el = event.target

    el.style.height = 'auto'
    el.style.height = `${el.scrollHeight}px`
  }

  const textarea = document.querySelectorAll('.textarea-expand')

  for (let i = 0; i < textarea.length; i++) {
    textarea[i].addEventListener('paste', autoExpand)
    textarea[i].addEventListener('input', autoExpand)
    textarea[i].addEventListener('keyup', autoExpand)
  }
}
